/* Creator LP "pick" buy box (sections/clp-pick.liquid): variant pills + the
 * per-country shipping line.
 *
 * SHIPPING LINE (2026-10-08)
 * The old line was a hardcoded "Free shipping above €50". The threshold is per
 * country (€50 NL/BE/IE/LU, €70 DE/FR/AT/IT/ES/PT/FI, 800 kr SE, 500 kr DK) and
 * M/L Welcome Bundles ship free everywhere (the shipping app's discount
 * function), so that line was wrong for most of the paid traffic.
 *
 * Server side (Liquid) renders the correct line for the market it knows
 * (snippets/nf-free-shipping-threshold.liquid, same source as the
 * announcement bar). On the English root the visitor's country is only known
 * client side; assets/syba-free-shipping-live.js (window.SybaShipLive) does
 * the country re-resolution for the whole page, and this script re-renders
 * the line on every variant change.
 *
 * Rules, in order:
 *   1. grant   -> "Free shipping!"  (M/L Welcome Bundle: free in every market)
 *   2. price >= threshold -> "Free shipping!"
 *   3. else    -> "Free shipping above <threshold>"  (localized template)
 *
 * GALLERY (2026-10-10)
 * The media column is the product-page gallery (product-media-gallery snippet +
 * media-gallery.js). Each S/M/L pill carries data-media = that variant's
 * featured media id; switching mirrors global.js updateMedia(): activate the
 * slide on every MediaGallery-<section> and hoist the matching lightbox item.
 */
(function () {
  'use strict';

  // Pure. opts: { priceCents, grant, thresholdCents, symbol, suffix, freeText, aboveTemplate, formatAmount }
  function shippingLine(o) {
    if (o.grant) return o.freeText;
    if (typeof o.thresholdCents === 'number' && o.thresholdCents > 0 && o.priceCents >= o.thresholdCents) return o.freeText;
    return String(o.aboveTemplate).replace('[amount]', o.formatAmount(o.thresholdCents, o.symbol, o.suffix));
  }

  // Pure: the gallery element id + slide id the product page uses for a variant image.
  function mediaTarget(sectionId, mediaId) {
    if (!sectionId || !mediaId) return null;
    return { galleryPrefix: 'MediaGallery-' + sectionId, slideId: sectionId + '-' + mediaId };
  }

  // Dawn's media gallery calls window.pauseAllMedia() on every active-media change, which pauses EVERY
  // <video> on the page, including autoplaying ones outside the pick block (the SYBASoil vs regular soil
  // clip further down). Resume those after a gallery switch; the gallery's own videos are left alone.
  function resumeAutoplayVideos() {
    var root = document.getElementById('clp-pick');
    var vids = document.querySelectorAll('video[autoplay]');
    for (var i = 0; i < vids.length; i++) {
      var v = vids[i];
      if (root && root.contains(v)) continue;
      if (v.paused) { try { var p = v.play(); if (p && p.catch) p.catch(function () {}); } catch (e) {} }
    }
  }

  function switchMedia(sectionId, mediaId) {
    var t = mediaTarget(sectionId, mediaId);
    if (!t) return;
    var galleries = document.querySelectorAll('[id^="' + t.galleryPrefix + '"]');
    for (var i = 0; i < galleries.length; i++) {
      if (typeof galleries[i].setActiveMedia === 'function') galleries[i].setActiveMedia(t.slideId, true);
    }
    var modal = document.querySelector('#ProductModal-' + sectionId + ' .product-media-modal__content');
    if (!modal) return;
    var item = modal.querySelector('[data-media-id="' + mediaId + '"]');
    if (item) modal.prepend(item);
  }

  // Pure: the section-rendering URL for a sibling page's pick section.
  function sectionUrl(href, sectionId) {
    var u = String(href).split('#')[0];
    // section_id= (one section, HTML) works on metaobject pages; the JSON ?sections= endpoint 404s there.
    return u + (u.indexOf('?') === -1 ? '?' : '&') + 'section_id=' + encodeURIComponent(sectionId);
  }

  // Inline <script>s inserted via innerHTML never run: re-create them (delivery countdown, etc.).
  // Only JavaScript is re-run. Data scripts (type="application/json", e.g. nf-bundle-contents' overrides
  // and variant prices) are left exactly as they are: re-creating them as JS threw a SyntaxError that
  // aborted the loop, skipped init() and made the tab fall back to a full page load.
  var JS_TYPES = /^(|text\/javascript|application\/javascript|module)$/i;
  function rerunScripts(wrapper) {
    wrapper.querySelectorAll('script').forEach(function (old) {
      if (old.src || !JS_TYPES.test((old.getAttribute('type') || '').trim())) return;
      var s = document.createElement('script');
      for (var i = 0; i < old.attributes.length; i++) s.setAttribute(old.attributes[i].name, old.attributes[i].value);
      s.textContent = old.textContent;
      old.parentNode.replaceChild(s, old);
    });
  }

  // Dawn's ModalDialog moves every <product-modal> out of its section into <body> on upgrade, so the
  // old lightbox survives an innerHTML swap and document.querySelector('#ProductModal-<id>') keeps
  // finding it: the zoom would show the bundle the page started on. Drop it before swapping.
  function cssEscape(id) { return (window.CSS && window.CSS.escape) ? window.CSS.escape(id) : String(id).replace(/([^\w-])/g, '\\$1'); }
  function removeStaleModals(sectionId) {
    var stale = document.querySelectorAll('#ProductModal-' + cssEscape(sectionId));
    for (var i = 0; i < stale.length; i++) stale[i].parentNode.removeChild(stale[i]);
    return stale.length;
  }

  // A plain left click; anything with a modifier or another button keeps the browser's own behaviour
  // (open in a new tab, etc.).
  function plainClick(ev) {
    return !(ev.metaKey || ev.ctrlKey || ev.shiftKey || ev.altKey || (ev.button && ev.button !== 0));
  }

  var swapSeq = 0; // the last click wins: an earlier, slower response is dropped
  function setSwapLoading(plants, wrapper, on) {
    plants.classList[on ? 'add' : 'remove']('is-loading');
    if (on) wrapper.setAttribute('aria-busy', 'true'); else wrapper.removeAttribute('aria-busy');
    // The old bundle must not be addable while the new one is on its way.
    var submits = wrapper.querySelectorAll('button[type="submit"]');
    for (var i = 0; i < submits.length; i++) submits[i].disabled = on;
  }

  // Plant-type tabs: fetch the sibling page's pick section and swap it in place (no page load).
  function bindPlantTabs(root) {
    var plants = root.querySelector('[data-clpk-plants]');
    if (!plants || plants.dataset.clpkBound === '1') return;
    plants.dataset.clpkBound = '1';
    var style = (new URLSearchParams(window.location.search).get('picker') || '').toLowerCase();
    if (/^(chips|cards|circles)$/.test(style)) {
      plants.className = plants.className.replace(/clpk__plants--\w+/, '') + ' clpk__plants--' + style;
    }
    var sectionId = plants.getAttribute('data-section-id');
    var wrapper = document.getElementById('shopify-section-' + sectionId);
    if (!sectionId || !wrapper || !window.fetch) return; // plain links keep working
    plants.addEventListener('click', function (ev) {
      var tab = ev.target.closest('[data-clpk-tab]');
      if (!tab || !plainClick(ev)) return;
      ev.preventDefault();
      // The selected tab stays put: its link points at the generic pick page, never leave the ad page for it.
      if (tab.classList.contains('is-active')) return;
      var href = tab.getAttribute('href');
      var key = tab.getAttribute('data-clpk-tab');
      var seq = ++swapSeq;
      setSwapLoading(plants, wrapper, true);
      var ctrl = window.AbortController ? new AbortController() : null;
      var timer = ctrl ? setTimeout(function () { ctrl.abort(); }, 10000) : null;
      fetch(sectionUrl(href, sectionId), { credentials: 'same-origin', signal: ctrl ? ctrl.signal : undefined })
        .then(function (r) { if (!r.ok) throw new Error(String(r.status)); return r.text(); })
        .then(function (html) {
          if (seq !== swapSeq) return; // superseded by a later click
          var doc = new DOMParser().parseFromString(html || '', 'text/html');
          var fresh = doc.getElementById('shopify-section-' + sectionId);
          // A missing sibling page answers 200 with an empty wrapper: that is a failure, not a swap.
          if (!fresh || !fresh.querySelector('[data-clpk-plants]')) throw new Error('no section html');
          removeStaleModals(sectionId);
          var tabsTop = plants.getBoundingClientRect().top;
          // The Omega delivery app mounts its widget once, on page load; a block that arrives via innerHTML stays
          // empty. The line is the same for every bundle, so carry the already-rendered node over to the new block.
          var liveApp = wrapper.querySelector('[data-clpk-delivery-app]');
          if (liveApp && !(liveApp.innerText || '').trim()) liveApp = null;
          wrapper.innerHTML = fresh.innerHTML;
          rerunScripts(wrapper);
          var newApp = wrapper.querySelector('[data-clpk-delivery-app]');
          if (liveApp && newApp) newApp.parentNode.replaceChild(liveApp, newApp);
          document.dispatchEvent(new Event('shopify:section:load')); // nf-bundle-contents re-inits on this
          init();
          // The page URL stays the ad's page: the swapped block comes from a generic per-creator pick page.
          // Keep the tabs where the finger is (the title above them changes length between bundles).
          var np = wrapper.querySelector('[data-clpk-plants]');
          if (np) {
            var moved = np.getBoundingClientRect().top - tabsTop;
            if (Math.abs(moved) > 2) window.scrollBy(0, moved);
            var nt = np.querySelector('[data-clpk-tab="' + key + '"]');
            if (nt && nt.focus) { try { nt.focus({ preventScroll: true }); } catch (e) { nt.focus(); } }
          }
        })
        .catch(function () { if (seq === swapSeq) window.location.href = href; }) // fall back to a normal navigation
        .then(function () { if (timer) clearTimeout(timer); if (seq === swapSeq) setSwapLoading(plants, wrapper, false); });
    });
  }

  window.SybaClpPick = { shippingLine: shippingLine, mediaTarget: mediaTarget, switchMedia: switchMedia, resumeAutoplayVideos: resumeAutoplayVideos, sectionUrl: sectionUrl, rerunScripts: rerunScripts, removeStaleModals: removeStaleModals, plainClick: plainClick, init: function () { init(); } };

  // The Omega delivery app block decides at runtime whether it renders (its own "show on pages" setting).
  // If it stays empty, reveal the app-free twin so the slot is never blank.
  function deliveryFallback(root) {
    var app = root.querySelector('[data-clpk-delivery-app]');
    var fb = root.querySelector('[data-clpk-delivery-fallback]');
    if (!app || !fb || fb.dataset.clpkWatched === '1') return;
    fb.dataset.clpkWatched = '1';
    var tries = 0;
    (function check() {
      // innerText, not textContent: the app's own inline <script> snippets would count as text otherwise.
      if ((app.innerText || '').trim()) { fb.hidden = true; return; }
      if (++tries < 12) { setTimeout(check, 500); return; } // ~6 s for the app script to render
      fb.hidden = false;
    })();
  }

  function init() {
    var root = document.getElementById('clp-pick');
    if (!root) return;
    bindPlantTabs(root);
    deliveryFallback(root);
    if (root.dataset.clpkInit === '1') return; // a swapped-in section is a fresh element
    root.dataset.clpkInit = '1';
    var id = root.querySelector('[data-clpk-id]');
    var price = root.querySelector('[data-clpk-price]');
    var compare = root.querySelector('[data-clpk-compare]');
    var save = root.querySelector('[data-clpk-save]');
    var ship = root.querySelector('[data-clpk-ship]');
    var inputs = root.querySelectorAll('.clpk__variant input');
    var form = root.querySelector('product-form');
    var sectionId = form ? form.getAttribute('data-section-id') : null;
    var S = window.SybaShipLive || null;

    var market = ship ? {
      thresholdCents: parseInt(ship.getAttribute('data-threshold-cents'), 10) || 0,
      symbol: ship.getAttribute('data-symbol') || '€',
      suffix: ship.getAttribute('data-suffix') === '1'
    } : null;

    function selected() {
      for (var i = 0; i < inputs.length; i++) if (inputs[i].checked) return inputs[i];
      return null;
    }
    function renderShip() {
      if (!ship || !market || !S) return; // without the shared helper the server text stands
      // min(native, Intelligems free-shipping group): assets/syba-ship-threshold.js
      var m = S.effective ? S.effective(market) : market;
      var sel = selected();
      var cents = sel ? parseInt(sel.getAttribute('data-cents'), 10) : parseInt(ship.getAttribute('data-current-cents'), 10);
      var grant = sel ? sel.getAttribute('data-grant') === '1' : ship.getAttribute('data-current-grant') === '1';
      ship.textContent = shippingLine({
        priceCents: cents || 0, grant: grant,
        thresholdCents: m.thresholdCents, symbol: m.symbol, suffix: m.suffix,
        freeText: ship.getAttribute('data-free'), aboveTemplate: ship.getAttribute('data-tpl'),
        formatAmount: S.formatAmount
      });
    }

    for (var i = 0; i < inputs.length; i++) {
      inputs[i].addEventListener('change', function () {
        var inp = this;
        if (id) {
          id.value = inp.value;
          id.setAttribute('value', inp.value); // the bundle-contents cards watch this attribute
          id.dispatchEvent(new Event('change', { bubbles: true }));
        }
        if (price) price.textContent = inp.getAttribute('data-price');
        if (compare) compare.textContent = inp.getAttribute('data-compare') || '';
        if (save) {
          var s = inp.getAttribute('data-save');
          if (s) { save.hidden = false; save.textContent = '-' + s + '%'; } else { save.hidden = true; }
        }
        renderShip();
        switchMedia(sectionId, inp.getAttribute('data-media'));
        resumeAutoplayVideos();
      });
    }

    // Welcome Bundles open on M (Liquid), but the gallery snippet activates the first
    // variant's slide server side: bring the slide in line with the checked pill.
    (function syncGalleryToSelection() {
      var sel = selected();
      if (!sel || !sectionId) return;
      var media = sel.getAttribute('data-media');
      var active = document.querySelector('#MediaGallery-' + sectionId + ' [data-media-id].is-active');
      if (media && !(active && active.getAttribute('data-media-id') === sectionId + '-' + media)) { switchMedia(sectionId, media); resumeAutoplayVideos(); }
    })();

    if (S && market) {
      S.onCountry(function (iso) {
        if (root.isConnected === false) return; // this section was swapped out
        var m = S.marketFor(iso);
        if (!m) return;
        market = m;
        renderShip();
      });
    }
    // Intelligems group settled/changed: re-render with the new effective threshold.
    if (S && market && window.SybaShipThreshold && typeof window.SybaShipThreshold.onChange === 'function') {
      var igApplied = false;
      window.SybaShipThreshold.onChange(function (cents) {
        if (root.isConnected === false) return;
        // No group and nothing applied before: leave the server text alone.
        if (cents == null && !igApplied) return;
        igApplied = cents != null;
        renderShip();
      });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();

})();
